import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { graphql } from 'react-apollo';
import compose from 'lodash.flowright';

import ProfilePageHelmet from '../ProfilePageHelmet/ProfilePageHelmet';
import ContentWrap from '../../../../../../../../components/global/ContentWrap';
import { getAsset } from '../../../../../../../../util/assets';
import Button from '../../../../../../../../components/global/Button';
import { MeQuery } from '../../../../../../../../graphql/queries/account';
import { getAccountProfileName } from '../../../../helpers';
import ProfilePageHero from '../../../ProfilePageHero/ProfilePageHero';

const propTypes = {
  accountProfile: PropTypes.shape({
    id: PropTypes.string,
  }).isRequired,
  onGoBack: PropTypes.func,
};

const ProUserPageNullState = ({ accountProfile, onGoBack }) => {
  return (
    <>
      <ProfilePageHelmet accountProfile={accountProfile} />
      <ProfilePageHero accountProfile={accountProfile} onGoBack={onGoBack} />
      <ContentWrap size="md" noShadow className="text-center">
        <div className="pro-user-page-null-state">
          <div className="my-2">
            <img
              src={getAsset('/empty-folder.svg')}
              alt="Empty library"
              width="150px"
            />
          </div>

          <div className="d-flex align-items-start">
            <div className="flex-auto">
              <p className="text-extra-bold text-dark mt-2">
                There are no public events happening yet!
              </p>
              <p>
                In the meantime, you could visit{' '}
                <strong>{getAccountProfileName(accountProfile)}</strong>
                &rsquo;s website to look for updates or create your very own
                event on Waldo!
              </p>
            </div>
          </div>

          <div className="pro-directory-button-container">
            {accountProfile.site_url && (
              <Button
                target="_blank"
                href={accountProfile.site_url}
                btnStyle="primary"
                btnOutline
                className="d-flex align-items-center"
              >
                Visit Website
              </Button>
            )}
          </div>
        </div>
      </ContentWrap>
    </>
  );
};

ProUserPageNullState.propTypes = propTypes;

const withUserData = graphql(MeQuery, {
  props: ({ data }) => ({
    user: data?.me,
  }),
  skip: ({ authenticated }) => !authenticated,
});

const mapStateToProps = ({ auth }) => ({
  authenticated: auth.authenticated,
});

export default compose(
  connect(mapStateToProps),
  withUserData,
)(ProUserPageNullState);
